import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OktaAuthGuard } from '../app.guard';
import { LayoutComponent } from '../layout/layout/layout.component';
import { ViewCpeComponent } from './vulnerabilities/viewcpe/viewcpe.component';
import { ViewSignalComponent } from './worldwatch/viewsignal/viewsignal.component';
import { ViewTagComponent } from './worldwatch/viewtags/viewtag.component';
import { ViewVulnComponent } from './vulnerabilities/viewvuln/viewvuln.component';
import { VulnerabilitiesComponent } from './vulnerabilities/dashboard/vulnerabilities.component';
import { WorldWatchComponent } from './worldwatch/dashboard/worldwatch.component';
import { BlogComponent } from './rss/blog/blog.component';
import { EventsComponent } from './rss/events/events.component';
import { NewsComponent } from './rss/news/news.component';
import { WhitepapersComponent } from './rss/whitepapers/whitepapers.component';
import { ServicesComponent } from './services/services.component';
import { DashboardLayoutComponent } from '../layout/dashboardlayout/dashboardlayout.component';

const theme = "updates";
const image = "/assets/images/changes.svg";
const routes: Routes = [
  {
    path: 'updates',
    component: LayoutComponent,
    canActivate: [OktaAuthGuard],
    children: [
      { path: '', redirectTo: 'worldwatch', pathMatch: 'full' },
      {
        path: 'worldwatch/viewSignal/:signalRef',
        component: ViewSignalComponent,
        pathMatch: 'full',
        data: {
          title: 'pages.updates.viewSignal',
          urls: [{ title: 'menu.updates.worldwatch', url: '/updates/worldwatch/dashboard' }, {title: 'pages.updates.viewSignal'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'worldwatch/viewTag/:tag',
        component: ViewTagComponent,
        pathMatch: 'full',
        data: {
          title: 'pages.updates.viewTag',
          urls: [{ title: 'menu.updates.worldwatch', url: '/updates/worldwatch/dashboard' }, {title: 'pages.updates.viewTag'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'vulnerabilities/viewVuln/:cveRef',
        component: ViewVulnComponent,
        pathMatch: 'full',
        data: {
          title: 'pages.updates.viewVuln',
          urls: [{ title: 'menu.updates.vulnerabilities', url: '/updates/vulnerabilities/dashboard' }, {title: 'pages.updates.viewVuln'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'vulnerabilities/viewCpe/:cpeRef',
        component: ViewCpeComponent,
        pathMatch: 'full',
        data: {
          title: 'pages.updates.viewCpe',
          urls: [{ title: 'menu.updates.vulnerabilities', url: '/updates/vulnerabilities/dashboard' }, {title: 'pages.updates.viewCpe'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'blogs',
        component: BlogComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.rss.blog',
          urls: [{title: 'menu.updates.rss.blog'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'events',
        component: EventsComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.rss.events',
          urls: [{title: 'menu.updates.rss.events'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'news',
        component: NewsComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.rss.news',
          urls: [{title: 'menu.updates.rss.news'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'whitepapers',
        component: WhitepapersComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.rss.whitepapers',
          urls: [{title: 'menu.updates.rss.whitepapers'}],
          theme: theme,
          image: image
        }
      },
      {
        path: 'services',
        component: ServicesComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.ourServices',
          urls: [{title: 'menu.updates.ourServices'}],
          theme: theme,
          image: image
        }
      }
    ]
  },
  {
    path: 'updates',
    component: DashboardLayoutComponent,
    canActivate: [OktaAuthGuard],
    children: [
      { path: '', redirectTo: 'worldwatch', pathMatch: 'full' },
      {
        path: 'worldwatch/dashboard/:loadpage',
        component: WorldWatchComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.worldwatch',
          urls: [{ title: 'menu.updates.worldwatch' }],
          theme: theme,
          image: image
        }
      },
      {
        path: 'worldwatch/dashboard',
        component: WorldWatchComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.worldwatch',
          urls: [{ title: 'menu.updates.worldwatch' }],
          theme: theme,
          image: image
        }
      },
      {
        path: 'vulnerabilities/dashboard',
        component: VulnerabilitiesComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.vulnerabilities',
          urls: [{ title: 'menu.updates.vulnerabilities' }],
          theme: theme,
          image: image
        }
      },
      {
        path: 'vulnerabilities/dashboard/:loadpage',
        component: VulnerabilitiesComponent,
        pathMatch: 'full',
        data: {
          title: 'menu.updates.vulnerabilities',
          urls: [{ title: 'menu.updates.vulnerabilities' }],
          theme: theme,
          image: image
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UpdatesRoutingModule { }
